<template>
  <div class="columns">
    <div class="column">
      <sc-field
        label="Status"
        prop="status">
        <sc-logs-tracking-status
          v-model="filters.status"
          :option-all="true" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Sub Status"
        prop="subStatus">
        <sc-logs-tracking-sub-status
          v-model="filters.substatus"
          :status-id="filters.status"
          :option-all="true" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Tipo do evento">
        <sc-select
          v-model="filters.eventSource"
          @input="filters.logisticProviderId = null"
          expanded>
          <option
            v-for="type in listTypeEvents"
            :key="type.value"
            :value="type.value">
            {{ type.label }}
          </option>
        </sc-select>
      </sc-field>
    </div>

    <div
      class="column"
      v-if="filters.eventSource === 'LOGISTIC_PROVIDER'">
      <sc-field
        label="Transportadora"
        prop="logisticProviderId">
        <sc-logistic-provider-dropdown
          v-model="filters.logisticProviderId" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Período"
        prop="dateRange">
        <sc-range-date-picker
          v-model="filters.dateRange"
          :format="formatDate" />
      </sc-field>
    </div>

    <div class="column is-3">
      <sc-field
        label="Tipo específico">
        <sc-field>
          <sc-select v-model="filters.typeSpecific">
            <option value="shipmentOrderNumber">Pedido</option>
            <option value="invoiceNumber">Nota fiscal</option>
            <option value="originalCode">Código original</option>
            <option value="invoiceKey">Chave da Nota</option>
            <option value="trackingCode">Cód. Rastreamento</option>
            <option value="hash">Lote</option>
          </sc-select>
          <sc-input
            v-model="filters.valueSpecific"
            :placeholder="placeholderFilterSpecific" />
        </sc-field>
      </sc-field>
    </div>

  </div>
</template>

<script>
  import {
    ScField,
    ScSelect,
    ScInput,
    ScLogisticProviderDropdown,
    ScRangeDatePicker,
  } from '@intelipost-js/secure-components';
  import { Moment } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';
  import ScLogsTrackingStatus from '../sc-logs-tracking-status/ScLogsTrackingStatus.vue';
  import ScLogsTrackingSubStatus from '../sc-logs-tracking-sub-status/ScLogsTrackingSubStatus.vue';

  const { mapState } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'sc-logs-tracking-filters',
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    computed: {
      placeholderFilterSpecific() {
        const placeholders = {
          shipmentOrderNumber: 'Nº do pedido',
          invoiceNumber: 'Nº da nota fiscal',
          originalCode: 'Código original',
          invoiceKey: 'Chave da Nota Fiscal',
          trackingCode: 'Código de rastreamento',
          hash: 'Lote',
        };

        return placeholders[this.filters.typeSpecific];
      },
      ...mapState([
        'listTypeEvents',
      ]),
    },
    methods: {
      formatDate({ start, end }) {
        return {
          start: Moment(start).format('YYYY-MM-DD'),
          end: Moment(end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScField,
      ScSelect,
      ScInput,
      ScLogisticProviderDropdown,
      ScRangeDatePicker,
      ScLogsTrackingStatus,
      ScLogsTrackingSubStatus,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/components/sc-logs-tracking-filters/ScLogsTrackingFilters.vue